import { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const userDocRef = doc(db, 'users', firebaseUser.uid);
        const userDoc = await getDoc(userDocRef);
        let userData = userDoc.exists() ? userDoc.data() : {};

        // Check if trial has expired
        const now = new Date();
        const trialEndDate = userData.trialEndDate ? new Date(userData.trialEndDate) : null;
        if (userData.status === "trial" && trialEndDate && now > trialEndDate) {
          // Update status to "pending payment" in Firestore
          await updateDoc(userDocRef, { status: "pending payment" });
          console.log(`Updated status to 'pending payment' for user: ${firebaseUser.uid}`);
          userData.status = "pending payment"; // Update local data
        }

        setUser({
          ...firebaseUser,
          role: userData.role || 'user',
          emailVerified: firebaseUser.emailVerified,
          status: userData.status || 'pending payment', // Default if missing
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);